import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListItem } from '@material-library';

@Component({
  selector: 'app-help-sign-in-dialog',
  templateUrl: './help-sign-in-dialog.component.html',
  styleUrls: ['./help-sign-in-dialog.component.scss']
})
export class HelpSignInDialogComponent {

  @Input() openHelpDialog: boolean = false;
  @Output() openHelpDialogChange = new EventEmitter<boolean>();
  public helpCategories: ListItem[] = [];

  ngOnInit(): void {
    this.initHelpCategories();
  }

  initHelpCategories = () => {
    this.helpCategories = [
      {
        text: 'Get help signing in',
        url: 'http://www.sync.com/help/signinhelp',
      },
    ].map((item) => {
      return {
        primaryText: item.text,
        divider: true,
        isInteractive: true,
        onClick: () => window.open(item.url),
        trail2AdornmentConfig: {
          enabled: true,
          type: 'icon',
          size: 'large',
          iconType: 'primary',
          iconName: 'chevron-right',
        },
      };
    });
  };
  

  closeHelpDialog = () => {
    this.openHelpDialog = false;
    this.openHelpDialogChange.emit(this.openHelpDialog);
  }
}
